import { Client, fetchAdapter } from '@alphastep/api-client';

const baseUrl = (import.meta.env as { VITE_API_BASE?: string }).VITE_API_BASE ?? '';

export const api = new Client({
  baseUrl,
  adapter: fetchAdapter,
  getAccessToken: () => localStorage.getItem('admin_access_token') ?? undefined,
  // 401 交给 api/install-auth-interceptor.ts 的全局拦截器统一续期 + 重放，
  // 这里不再自行清 token 跳转——那会抢在续期之前把人踢出去
  onUnauthorized: () => {},
});
